import { FieldType } from './field';
import { SearchItem } from './search-item';

export enum SearchArgumentStatus {
  CREATE,
  EDIT
}

export enum State {
  INIT = 'INIT',
  KEYWORD = 'KEYWORD',
  KEYWORD_VALUE = 'KEYWORD_VALUE',
  VALUE = 'VALUE',
  OPERATOR = 'OPERATOR'
}

export class SearchArgument {
  public path: string; // FIXME doublon searchItem.path, supprimer
  public fieldType: FieldType;
  constructor(
    public fragment: string = null,
    public searchItem: SearchItem = null,
    public state: State = null,
    public status: SearchArgumentStatus = SearchArgumentStatus.CREATE
  ) {
    if (searchItem !== null) {
      this.path = this.searchItem.path;
      this.fieldType = searchItem.fieldType;
    } else {
      this.path = null;
      this.fieldType = null;
    }
  }

  // public isAuthorizeSearchByDirectInput(): boolean {
  //   if (this.searchItem) {
  //     return !!this?.searchItem?.authorizeSearchByDirectInput;
  //   } else {
  //     this.path = null;
  //     this.fieldType = null;
  //     this.authorizeSearchByDirectInput = true;
  //     this.callAutocompletionOnDirectInput = true;
  //   }
  // }

  public static createEmptySearchArgument(): SearchArgument {
    const item = new SearchItem(-1, undefined, undefined, undefined, true, undefined);
    return new SearchArgument(undefined, item, State.INIT , SearchArgumentStatus.CREATE);
  }
}
